import { useFormContext, UseFormReturn, useWatch } from 'react-hook-form'
import { countryCodes } from '../../constants/countries'
import { InstallationFormModel } from '../forms'

export const useInstallationForm = (): UseFormReturn<InstallationFormModel> => {
  return useFormContext<InstallationFormModel>()
}

export const useInstallationIsGerman = (): boolean => {
  const { control } = useInstallationForm()
  return useWatch({ control, name: 'generalSettings.location.country' }) === countryCodes.germany
}
